// WHIT-506: a class list from parts, leaving out the ones not set. A
// template string printed an unset prop as the class "undefined" (or
// "false"), which showed in the page's markup. Pure, so
// `node --test web/utils/classNames.test.js` can load it.

/**
 * @param {...(string | false | null | undefined)} parts
 * @returns {string}
 */
const classNames = (...parts) => parts.filter(Boolean).join(' ');

module.exports = { classNames };
